import { useSelector } from 'react-redux'

const useUser = () => {
  const selector = state => state.authReducer.userObject
  const user = useSelector(selector)
  return { user }
}

export default useUser
